import { DocumentTags } from './enums'

export function getLanguageProficiencyFieldsInfo(testType: string) {
  switch (testType) {
    case 'IELTS':
      return {
        minOverall: 0,
        maxOverall: 9,
        minSubscore: 0,
        maxSubscore: 9,
        step: 0.5,
        codeLabel: 'TRF number',
        fileType: DocumentTags.LANGUAGE_TEST_IELTS,
      }
    case 'TOEFL':
      return {
        minOverall: 0,
        maxOverall: 120,
        minSubscore: 0,
        maxSubscore: 30,
        step: 1,
        codeLabel: 'Appointment number',
        fileType: DocumentTags.LANGUAGE_TEST_TOEFL,
      }
    case 'PTE':
      return {
        minOverall: 10,
        maxOverall: 90,
        minSubscore: 10,
        maxSubscore: 90,
        step: 1,
        codeLabel: 'Score report code',
        fileType: DocumentTags.LANGUAGE_TEST_PTE,
      }
    case 'DUOLINGO':
      return {
        minOverall: 10,
        maxOverall: 160,
        minSubscore: 10,
        maxSubscore: 160,
        step: 1,
        codeLabel: 'Certificate ID',
        fileType: DocumentTags.LANGUAGE_TEST_DUOLINGO,
      }
    case 'OTHER':
      return {
        fileType: DocumentTags.LANGUAGE_TEST_OTHER,
      }
    case 'CAEL':
      return {
        fileType: DocumentTags.LANGUAGE_TEST_CAEL,
      }
    case 'MET':
      return {
        fileType: DocumentTags.LANGUAGE_TEST_MET,
      }
    case 'CAMBRIDGE':
      return {
        fileType: DocumentTags.LANGUAGE_TEST_CAMBRIDGE,
      }
    case 'EPP':
      return {
        fileType: DocumentTags.LANGUAGE_TEST_EPP,
      }
    case 'CANTEST':
      return {
        fileType: DocumentTags.LANGUAGE_TEST_CANTEST,
      }
    case 'LANGUAGECERT_ESOL':
      return {
        fileType: DocumentTags.LANGUAGE_TEST_LANGUAGECERT_ESOL,
      }
    case 'LEAP_4_ADVANCED':
      return {
        fileType: DocumentTags.LANGUAGE_TEST_LEAP_4_ADVANCED,
      }
  }

  return null
}

export type Subscores = 'speaking' | 'writing' | 'reading' | 'listening'
export type IntegratedSubscores = 'production' | 'literacy' | 'comprehension' | 'conversation'

export function getSubscoresOrder(
  testType: string,
): Array<{ id: string; label: string; name: Subscores | IntegratedSubscores }> {
  switch (testType) {
    case 'TOEFL':
      return [
        { id: crypto.randomUUID(), label: 'Reading', name: 'reading' },
        { id: crypto.randomUUID(), label: 'Listening', name: 'listening' },
        { id: crypto.randomUUID(), label: 'Speaking', name: 'speaking' },
        { id: crypto.randomUUID(), label: 'Writing', name: 'writing' },
      ]
    case 'PTE':
      return [
        { id: crypto.randomUUID(), label: 'Listening', name: 'listening' },
        { id: crypto.randomUUID(), label: 'Reading', name: 'reading' },
        { id: crypto.randomUUID(), label: 'Speaking', name: 'speaking' },
        { id: crypto.randomUUID(), label: 'Writing', name: 'writing' },
      ]
    case 'DUOLINGO':
      return [
        { id: crypto.randomUUID(), label: 'Speaking', name: 'speaking' },
        { id: crypto.randomUUID(), label: 'Writing', name: 'writing' },
        { id: crypto.randomUUID(), label: 'Reading', name: 'reading' },
        { id: crypto.randomUUID(), label: 'Listening', name: 'listening' },
      ]
    case 'DUOLINGO_INTEGRATED':
      return [
        { id: crypto.randomUUID(), label: 'Production', name: 'production' },
        { id: crypto.randomUUID(), label: 'Literacy', name: 'literacy' },
        { id: crypto.randomUUID(), label: 'Comprehension', name: 'comprehension' },
        { id: crypto.randomUUID(), label: 'Conversation', name: 'conversation' },
      ]
    default:
      return [
        { id: crypto.randomUUID(), label: 'Listening', name: 'listening' },
        { id: crypto.randomUUID(), label: 'Reading', name: 'reading' },
        { id: crypto.randomUUID(), label: 'Writing', name: 'writing' },
        { id: crypto.randomUUID(), label: 'Speaking', name: 'speaking' },
      ]
  }
}

export function validateSubscore(testType: string, score: number): true | string {
  const fieldsInfo = getLanguageProficiencyFieldsInfo(testType)
  if (!fieldsInfo) return true

  const { minSubscore, maxSubscore } = fieldsInfo

  if (score < (minSubscore || 0) || score > (maxSubscore || 0)) {
    return 'Invalid score'
  }

  return true
}
